import axios from 'axios';

/**
 * Send a Slack message to #ruttl-user-events on Brucira workspace.
 * @param {String} text Text message to send.
 * @returns {Promise<any>}
 */

export default (text) => axios.post('/user-event', { text });
